import { Component } from '@angular/core';

import { Request } from '../../shared/models/request';
import { ExamineeRequestService } from '../examinee/examinee-request.service';

const steps: any[] = [
    { activeName: "Examinee Details", inactiveName: "Examinee" },
    { activeName: "Testing Information", inactiveName: "Test" },
    { activeName: "Reason for Request", inactiveName: "Reason" },
    { activeName: "Plan Details", inactiveName: "Plan" },
    { activeName: "Accommodations/Support", inactiveName: "Accomms/Support" },
    { activeName: "Documentation", inactiveName: "Documentation" },
    { activeName: "Review", inactiveName: "Review" }
];
@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.css']
})
export class StepperComponent {

    public activeIdx: number;
    public request: Request;
    public planSubmitted: string;
    public docSubmitted: string;

    public steps: any[];

    constructor(private reqService: ExamineeRequestService) {
        this.steps = [...steps];
        const req = this.reqService.currentRequest;
        this.activeIdx = req ? req.activeIdx : 0;
        this.setActiveRequest(req);
    }
    setActiveRequest(req: Request) {
        this.request = req;
        req && this.reqService.getExamineeRequest(req.requestId).subscribe(
            data => {
                this.reqService.getRequestStatusCode(data[0].REQUEST_STATUS_CODE_ID).subscribe(
                    statusCode => {
                        this.request.requestStatusCd = statusCode[0].STATUS_CD;
                    }
                );
            }
        );
    }


    isInReview() {
        return this.request && ['AutoApproved', 'Pending', 'Assigned', 'InReview', 'Reconsider'].includes(this.request.requestStatusCd);
    }

    isInReconsiderIncomplete() {
        return this.request && ['ReconsiderIncomplete'].includes(this.request.requestStatusCd);
    }
    isInApprovedorNotApproved() {
        return this.request && ['Approved', 'NotApproved', 'PartiallyApproved'].includes(this.request.requestStatusCd);
    }

    onRequestSave(req: Request, proceed: boolean) {
        this.setActiveRequest(req);
        this.activeIdx = req ? req.activeIdx : 0;
        if (proceed) {
            this.goToNextStep();
        }
    }
    getPreviousRecordDetails() {
        return this.request;
    }

    goToStep(idx: number) {
        if (idx <= 5 && this.isInReview()) {
            return;
        }
        if (idx <= 0 && this.isInReconsiderIncomplete()) {
            return;
        }
        this.request.activeIdx = idx;
        sessionStorage.setItem('currentStudent', JSON.stringify(this.request));
        this.activeIdx = idx;
    }

    goToNextStep() {
        const examineeSubmitted = sessionStorage.getItem("examineeSubmitted");
        const testSubmitted = sessionStorage.getItem("testSubmitted");
        const reasonSubmitted = sessionStorage.getItem("reasonSubmitted");
        const planSubmitted = sessionStorage.getItem("planSubmitted");
        const accomSubmitted = sessionStorage.getItem("accomSubmitted");
        const docSubmitted = sessionStorage.getItem("docSubmitted");
        this.request.activeIdx = this.request.activeIdx + 1;
        sessionStorage.setItem('currentStudent', JSON.stringify(this.request));
        // if (this.activeIdx < (this.steps.length - 1)) {
        //     this.activeIdx++;
        // }
        if (this.activeIdx === 0) {
            if (examineeSubmitted === "true") {
                this.activeIdx = 1;
            }
        } else if (this.activeIdx === 1) {
            if (testSubmitted === "true") {
                this.activeIdx = 2;
            }
        } else if (this.activeIdx === 2) {
            if (reasonSubmitted === "true") {
                this.activeIdx = 3;
            }
        } else if (this.activeIdx === 3) {
            if (planSubmitted === "true") {
                this.activeIdx = 4;
            }
        } else if (this.activeIdx === 4) {
            if (accomSubmitted === "true") {
                this.activeIdx = 5;
            }
        } else if (this.activeIdx === 5) {
            if (docSubmitted === "true") {
                this.activeIdx = 6;
            }
        }
    }

    goToPrevStep() {
        this.request.activeIdx = this.request.activeIdx - 1;
        sessionStorage.setItem('currentStudent', JSON.stringify(this.request));
        if (this.activeIdx > 0) {
            this.activeIdx--;
        }
    }
}



// WEBPACK FOOTER //
// ./client/views/request/stepper/stepper.component.ts